import { GET_REPORT_DEFINITIONS_SUCCESS } from '../../actions/constants';

export default (previousState = {}, { type, payload }) => {
    if (type === GET_REPORT_DEFINITIONS_SUCCESS) {
        return payload;
    }
    return previousState;
};
